import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

// flash-on's bolt split by a gap along the diagonal, with the slash drawn in
// that gap, so the slash reads clearly without a mask.
export const FlashOff = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="flash off icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      d="M16 1L10.33 7.36L16.48 13.51L20.5 9H14.5L16 1ZM7.52 10.49L3.5 15H9.5L8 23L13.67 16.64L7.52 10.49ZM4.38 2.62L21.38 19.62A1.25 1.25 0 0 1 19.62 21.38L2.62 4.38A1.25 1.25 0 0 1 4.38 2.62Z"
    />
  </svg>
)
